import React from 'react'
import { Stack, Heading, Text, Checkbox } from '@/components/lib'

export default function Terms ({ value, onChange, agreementStatement }) {
  return (
    <Stack spacing={3} p={5} rounded='lg' bg='bg.subtle'>
      <Heading as='h4' size='md'>Processing your data</Heading>
      <Text>In order to provide this service Trialflare will securely process and store your data in accordance with our Privacy Policy. To continue, please indicate that you have read and understand our Terms of Use and Privacy Policy, which can both be found <Text as='a' color='primary.500' href='https://trialflare.com/legal' target='_blank' rel='noopener noreferrer'>by clicking here</Text>.</Text>
      <Checkbox iconSize='lg' colorPalette='green' mt={5} isChecked={value} onChange={e => onChange(e.checked)}>
        {agreementStatement || 'I have read and agree to the Trialflare Terms of Use and Privacy Policy'}
      </Checkbox>
    </Stack>
  )
}
